import { FileViewerEmptyPreviewStyled } from './styles/FileViewerEmptyPreviewStyled'
import { useFileViewerContext } from '../../FileViewerContext'
import { Card } from '@ui/elements/Card'
import { Header } from '@ui/elements/Header'
import { IconFile } from '@ui/elements/Icon/components/IconFile'
import { Space } from '@ui/elements/Space'

export interface IFileViewerEmptyPreviewProps {}

export const FileViewerEmptyPreview = () => {
  const { strings } = useFileViewerContext()

  return (
    <FileViewerEmptyPreviewStyled>
      <Card>
        <Card.Content>
          <Space align='center'>
            <IconFile size={64} />
            <Header as='h5'>{strings.noFileSelected}</Header>
          </Space>
        </Card.Content>
      </Card>
    </FileViewerEmptyPreviewStyled>
  )
}
